import { render, staticRenderFns } from "./RepaymentCard.vue?vue&type=template&id=0afefa88&scoped=true&"
import script from "./RepaymentCard.vue?vue&type=script&lang=ts&"
export * from "./RepaymentCard.vue?vue&type=script&lang=ts&"
import style0 from "./RepaymentCard.vue?vue&type=style&index=0&id=0afefa88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afefa88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle,VDivider,VExpandTransition,VSpacer,VSubheader})
